// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"play-circle-stroke"},"children":[{"tag":"circle","attrs":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"props.fillColor1"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16.25 11.9997L9.5 15.8968L9.5 8.10254L16.25 11.9997Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.25 11.9997L9.5 15.8968L9.5 8.10254L16.25 11.9997Z","strokeWidth":"props.strokeWidth"}}]}]};

const PlayCircleStrokeIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'play-circle-stroke',
    ref,
    icon: element,
  },
));

PlayCircleStrokeIcon.displayName = 'PlayCircleStrokeIcon';

export default PlayCircleStrokeIcon;
